import { useState } from 'react';

export const usePlayableComponent = () => {
  const [isCovered, setIsCovered] = useState<boolean>(true);
  return {
    isCovered,
    setIsCovered,
  };
};
